let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hAWFl")).then(() => parcelRequire('bgS4M'));